import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseOrderLine, PurchaseOrderLineCreate, PurchaseOrderLineFilter } from '../data/purchaseOrderLine';

export function createPurchaseOrderLineService(client: AxiosInstance) {
  return createCrudService<PurchaseOrderLine, PurchaseOrderLineCreate, PurchaseOrderLineFilter>(
    client,
    '/purchase/PurchaseOrderLine',
    'id',
  );
}

export type PurchaseOrderLineService = CrudService<PurchaseOrderLine, PurchaseOrderLineCreate, PurchaseOrderLineFilter>;
